import Colors from "../helpers/Colors";
import { PlateColor } from "../types/Tags";

export default function PlateImage({ color, size, percent, dishID }: {
  color: PlateColor;
  size: number;
  percent: number;
  dishID: string;
}) {
  const imageSize = size;
  const decorationSize = size * 1.3;
  const mm = (decorationSize - imageSize) / 2;

  return (
    <div style={{
      display: 'flex',
      position: 'relative'
    }}>
      <img src={`/images/${dishID}.jpg`}
        alt=""
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src = '/images/unk.png';
        }}
        style={{
          width: `${imageSize}px`,
          height: `${imageSize}px`,
          objectFit: 'cover',
          borderRadius: '50%',
        }} />
      <div style={{
        position: 'absolute',
        background: Colors.getColor(color),
        //Proportional thickness
        mask: `radial-gradient(farthest-side, transparent ${decorationSize / 2 - decorationSize * 0.05}px, black ${decorationSize / 2 - decorationSize * 0.05 + 1}px, black ${decorationSize / 2 - 1}px, transparent ${decorationSize / 2}px)`,
        width: `${decorationSize}px`,
        height: `${decorationSize}px`,
        margin: `${-mm}px 0px 0px ${-mm}px`,
        zIndex: 2,
      }} />
    </div>
  )
}